"use client";
import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { useId as u } from "react";
import { FieldHelperText as B } from "../Field/HelperText/FieldHelperText.js";
import { FieldErrorText as L } from "../Field/ErrorText/FieldErrorText.js";
import { formToggleVariants as h } from "./FormToggle.variants.js";
import { useFormToggleProps as p } from "./useFormToggleProps.js";
const s = h, w = h.definition().defaultVariants, $ = ({
  children: y,
  className: I,
  errorText: n,
  helperText: c,
  labelIcon: d,
  labelPosition: v = w.labelPosition,
  labelText: l,
  ...e
}) => {
  !l && !(e.ariaLabel || e.ariaLabelledBy) && console.error(
    "Either `ariaLabel` or `ariaLabelledBy` is required when `labelText` is not provided."
  );
  const x = u(), o = u(), m = e.id || x, a = e.isInvalid && !!n, b = !a && !!c, N = p(e, {
    ariaDescribedBy: ((e.ariaDescribedBy || "") + (a || b ? ` ${o}` : "")).trim(),
    id: m
  }), i = {
    isDisabled: e.isDisabled || !1,
    isInvalid: e.isInvalid || !1,
    labelPosition: v
  }, T = s.root({
    className: I,
    ...i
  }), g = s.content(), D = s.container(), S = s.label(i), F = s.labelIcon(i), f = s.supportText(i);
  return /* @__PURE__ */ r("div", { className: T, children: [
    y(N),
    !!l && /* @__PURE__ */ r("div", { className: g, children: [
      !!d && /* @__PURE__ */ t("div", { className: F, children: d }),
      /* @__PURE__ */ r("div", { className: D, children: [
        /* @__PURE__ */ t("label", { className: S, htmlFor: m, children: l }),
        b && /* @__PURE__ */ t(
          B,
          {
            className: f,
            id: o,
            isDisabled: e.isDisabled,
            children: c
          }
        ),
        a && /* @__PURE__ */ t(L, { className: f, id: o, children: n })
      ] })
    ] })
  ] });
};
export {
  $ as FormToggle
};
